__turbopack_context__.v({
  "cardsContainer": "styles-module-scss-module__qorSia__cardsContainer",
  "container": "styles-module-scss-module__qorSia__container",
  "count": "styles-module-scss-module__qorSia__count",
  "departments": "styles-module-scss-module__qorSia__departments",
  "filterContainer": "styles-module-scss-module__qorSia__filterContainer",
  "root": "styles-module-scss-module__qorSia__root",
  "selectedLink": "styles-module-scss-module__qorSia__selectedLink",
});
